var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FF6A61",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.113 7.71l.094.083L16 14.585l6.793-6.792.094-.083c.392-.305.96-.278 1.32.083.39.39.39 1.024 0 1.414L17.415 16l6.792 6.793c.39.39.39 1.024 0 1.414-.36.36-.928.388-1.32.083l-.094-.083L16 17.415l-6.793 6.792-.094.083c-.392.305-.96.278-1.32-.083-.39-.39-.39-1.024 0-1.414L14.585 16 7.793 9.207c-.39-.39-.39-1.024 0-1.414.36-.36.928-.388 1.32-.083z",
    transform: "translate(-808 -163) translate(416 139) translate(392 24)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClose);
export default __webpack_public_path__ + "static/media/ico-close.5dc14b13587d9e73ba8983bc38f0091d.svg";
export { ForwardRef as ReactComponent };